export default __webpack_public_path__ + "messaging-support-illustration.webp";